import { GetServerSideProps, GetServerSidePropsContext } from 'next';
import absoluteUrl from 'next-absolute-url';

import { extractToken } from '@internal/api/system/utils';

export function withAuthRedirect<
  P extends Record<string, unknown> = Record<string, unknown>
>(gssp?: GetServerSideProps<P>): GetServerSideProps<P> {
  return async (context: GetServerSidePropsContext) => {
    const isTokenAvailable = extractToken(context);

    if (!isTokenAvailable) {
      const { protocol, host } = absoluteUrl(context.req);
      const redirect = `${protocol}//${host}${context.resolvedUrl ?? ''}`;
      const loginUrl = new URL(`${process.env.APP_LEMON_URL}/auth/login`);
      loginUrl.searchParams.append('redirect', redirect);

      return {
        redirect: {
          destination: loginUrl.toString(),
          permanent: false,
        },
      };
    }

    if (!gssp) {
      return { props: {} as P };
    }

    return gssp(context);
  };
}
